import API from '@dotcom/api-middleware';
import { queryOptions } from '@tanstack/react-query';
import { fulfillmentResponse, envelopPreviewResponse, previewResponse } from '../data';
import {
  ApiResponse,
  EnvelopePreviewResponse,
  FulfillmentResponse,
  PreviewResponseData,
  PreviewFormData,
  GetProjectResponseData,
} from '../global-types';
import { getAccountIdFromCookie } from '../utils/utility/get-account-id-from-cookie';
import { processResponse } from './middleware';

const PODService = new API();
const mockResponse = process.env.REACT_APP_MOCK_INITIALIZATION_SERVICE === 'true';

export const getPreview = async (
  projectId: string,
  formData: PreviewFormData,
): Promise<ApiResponse<PreviewResponseData>> => {
  const accountId = getAccountIdFromCookie();
  return new Promise((resolve, reject) => {
    if (mockResponse) {
      resolve(previewResponse);
      return;
    }

    // TODO Add correct type to return from preview endpoint, since there is still work to be done in this
    // endpoint , for now we keep an any type

    const response = PODService.post('/customization', `/${accountId}/${projectId}/preview`, formData);
    processResponse(response, resolve, reject);
  });
};

export const getEnvelopePreview = (projectId: string, formData: string): Promise<EnvelopePreviewResponse> => {
  const accountId = getAccountIdFromCookie();
  return new Promise((resolve, reject) => {
    if (mockResponse) {
      const response: EnvelopePreviewResponse = envelopPreviewResponse;
      resolve(response);
      return;
    }

    const response = PODService.post('/customization', `/${accountId}/${projectId}/envelope-preview`, formData);
    processResponse(response, resolve, reject);
  });
};

export const updateFulfillment = (
  quantity: number,
  deliveryMode: string,
  projectId: string | undefined,
): Promise<FulfillmentResponse> => {
  const accountId = getAccountIdFromCookie();
  return new Promise((resolve, reject) => {
    if (mockResponse) {
      const response = fulfillmentResponse;
      resolve(response);
    } else {
      const response = PODService.patch('customization/', `${accountId}/${projectId}/fulfillment`, {
        purchase_date: new Date(),
        purchase_quantity: quantity,
        delivery_mode: deliveryMode,
      });
      processResponse(response, resolve, reject);
    }
  });
};

export const getProjectDetails = (
  projectId: string,
  accountId = getAccountIdFromCookie(),
): Promise<ApiResponse<GetProjectResponseData>> => {
  return new Promise((resolve, reject) => {
    const response = PODService.get('customization/', `${accountId}/${projectId}/load`);
    processResponse(response, resolve, reject);
  });
};

export const projectDetailsQueryOptions = (projectId: string) => {
  const accountId = getAccountIdFromCookie();
  return queryOptions({
    queryKey: ['customization', accountId, projectId, 'details'],
    queryFn: () => getProjectDetails(projectId, accountId),
    retry: false,
  });
};
